import { GlobalGemVars } from '../types'

export function gemVar<T extends GlobalGemVars>(varName: T): `var(${T})` {
  return `var(${varName})`
}
